'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Video = require('./Video');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Video).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Video/index.js
// module id = 1312
// module chunks = 1